import React from "react";
import { useTheme } from "@/lib/theme";

const STATUS_LABELS = {
  pending: "Pending", accepted: "Accepted", in_progress: "In Progress", on_hold: "On Hold",
  waiting_material: "Waiting Material", completed: "Completed", waiting_approval: "Waiting Approval",
  approved: "Approved", rejected: "Rejected", cancelled: "Cancelled", terminated: "Terminated", reopened: "Reopened",
};

const C = {
  light: { muted: "#64748B", info: "#2A6DF4", warning: "#F59E0B", success: "#22C55E", danger: "#EF4444" },
  dark: { muted: "#94A3B8", info: "#4B87FF", warning: "#FBBF24", success: "#34D399", danger: "#F87171" },
};

function Pill({ bg, fg, children, testID }) {
  return (
    <span data-testid={testID} className="inline-flex self-start rounded-md px-2 py-[3px] text-[11px] font-bold tracking-[0.3px]" style={{ backgroundColor: bg, color: fg }}>
      {children}
    </span>
  );
}

export function StatusBadge({ status, testID }) {
  const { isDark } = useTheme();
  const c = isDark ? C.dark : C.light;
  const map = {
    pending: [isDark ? "#1F2937" : "#F3F4F6", c.muted],
    accepted: [isDark ? "#1E293B" : "#DBEAFE", c.info],
    in_progress: [isDark ? "#78350F" : "#FEF3C7", c.warning],
    on_hold: [isDark ? "#374151" : "#F3F4F6", c.muted],
    waiting_material: [isDark ? "#374151" : "#FEF3C7", c.warning],
    completed: [isDark ? "#064E3B" : "#D1FAE5", c.success],
    waiting_approval: [isDark ? "#1E3A8A" : "#DBEAFE", c.info],
    approved: [isDark ? "#064E3B" : "#D1FAE5", c.success],
    rejected: [isDark ? "#7F1D1D" : "#FEE2E2", c.danger],
    cancelled: [isDark ? "#374151" : "#F3F4F6", c.muted],
    terminated: [isDark ? "#7F1D1D" : "#FEE2E2", c.danger],
    reopened: [isDark ? "#78350F" : "#FEF3C7", c.warning],
  };
  const [bg, fg] = map[status] || map.pending;
  return <Pill bg={bg} fg={fg} testID={testID}>{STATUS_LABELS[status] || status}</Pill>;
}

export function PriorityBadge({ priority, testID }) {
  const { isDark } = useTheme();
  const c = isDark ? C.dark : C.light;
  const map = {
    low: [isDark ? "#1F2937" : "#F3F4F6", c.muted, "Low"],
    medium: [isDark ? "#1E3A8A" : "#DBEAFE", c.info, "Medium"],
    high: [isDark ? "#78350F" : "#FEF3C7", c.warning, "High"],
    critical: [isDark ? "#7F1D1D" : "#FEE2E2", c.danger, "Critical"],
  };
  const [bg, fg, label] = map[priority] || map.medium;
  return <Pill bg={bg} fg={fg} testID={testID}>{label}</Pill>;
}
